module.exports = __webpack_public_path__ + "static/img/2_1_2.5dc00e13.jpg";